import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getUtm() {
  const params = new URLSearchParams(window.location.search);
  const utm = {};
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach((k) => {
    const v = params.get(k);
    if (v) utm[k] = v;
  });
  return utm;
}

export function trackClick(button, product) {
  try {
    axios
      .post(
        `${API}/track`,
        { button, product, utm: getUtm(), path: window.location.pathname },
        { timeout: 4000 },
      )
      .catch(() => {});
  } catch (e) {
    /* tracking nunca bloqueia a navegação */
  }
}
